<div
    id="trading-symbols-view"
    class="trading-symbols-view d-flex flex-column align-items-start justify-content-start p-1 p-md-3"
>
    <h1>Trading Symbols</h1>

    <mat-form-field class="w-100">
        <input matInput type="search" [(ngModel)]="searchText" placeholder="Search symbols..." (keyup.enter)="search()" />
        <button matSuffix mat-icon-button aria-label="Search" (click)="search()">
            <mat-icon>search</mat-icon>
        </button>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon>
        Create New Symbol
    </button>

    <div class="table-responsive w-100">
        <table mat-table [dataSource]="tradingSymbols" class="mat-elevation-z8 my-3 w-100">
            <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>Symbol</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex flex-row align-items-center justify-content-start">
                        <div class="symbol-icon">
                            @if (element.icon) {
                                <img [src]="element.icon" [alt]="element.name" />
                            }
                            @if (!element.icon) {
                                <span class="logo mx-1 material-symbols-outlined">finance_mode</span>
                            }
                        </div>
                        {{ element.name }}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell">Company</th>
                <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell">{{ element.company }}</td>
            </ng-container>
            <ng-container matColumnDef="group">
                <th mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell">Group</th>
                <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell">{{ element.group }}</td>
            </ng-container>
            <ng-container matColumnDef="exchange">
                <th mat-header-cell *matHeaderCellDef class="d-none d-md-table-cell">Exchange</th>
                <td mat-cell *matCellDef="let element" class="d-none d-md-table-cell">{{ element.exchange }}</td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef class="d-none d-md-table-cell">Type</th>
                <td mat-cell *matCellDef="let element" class="d-none d-md-table-cell">{{ element.type }}</td>
            </ng-container>
            <ng-container matColumnDef="isActive">
                <th mat-header-cell *matHeaderCellDef>Active</th>
                <td mat-cell *matCellDef="let element">{{ element.isActive ? "+" : "-" }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex flex-row align-items-center gap-1">
                        <button mat-icon-button color="primary" (click)="edit(element)" matTooltip="Edit">
                            <mat-icon>edit</mat-icon>
                        </button>
                        @if (element.isActive) {
                            <button
                                mat-icon-button
                                color="accent"
                                (click)="deactivate(element)"
                                matTooltip="Deactivate"
                            >
                                <mat-icon>pause_circle</mat-icon>
                            </button>
                        }
                        @if (!element.isActive) {
                            <button mat-icon-button color="accent" (click)="activate(element)" matTooltip="Activate">
                                <mat-icon>play_circle</mat-icon>
                            </button>
                        }
                        <button mat-icon-button color="warn" (click)="delete(element)" matTooltip="Delete">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>

    <mat-paginator
        #paginator
        class="demo-paginator"
        (page)="pageChanged($event)"
        [length]="totalTradingSymbols"
        [pageSize]="pageSize"
        [disabled]="false"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 15, 25, 100]"
        [hidePageSize]="false"
        [pageIndex]="page"
        aria-label="Select page"
    >
    </mat-paginator>
</div>
